module.exports = __webpack_public_path__ + "img/inconsolata-light.d9ad2736.png";